import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { SUPPLIER_DETAIL } from '../../constants/routes';

export default class ActualEnterprises extends Component {

  findSalesOrdersByCulture(cultureId)
  {
      return this.props.salesOrders.filter(
          salesOrder => salesOrder.culture.id === cultureId
      );
  }

  render () {
    const { cultures } = this.props;

    return (
      <div className="actual-enterprises_wrapper">
          <div className="col-xs-12 panel  actual-enterprises_card panel-info">
            <div className="actual-enterprises_card_body panel-body">
                {cultures.map((grain, index) => {
                        const salesOrders = this.findSalesOrdersByCulture(grain.value);

                        return salesOrders.length ? <div className="actual-enterprises_card_body__group" key={`grain-` + index}>
                            <div
                                className="actual-enterprises_card_body__group_title">
                                {grain.label}
                            </div>

                            {salesOrders.map((salesOrder, index) =>
                                <div
                                    className="actual-enterprises_card_body__group_row"
                                    key={`enterprise-` + index}>
                                    <div className="actual-enterprises_card_body__group_row__name">
                                        {salesOrder.supplier ? (
                                            <Link
                                                to={SUPPLIER_DETAIL + '?id=' + salesOrder.supplier.id}>
                                                <strong
                                                    className={"mr-bottom-20 btn-block"}>
                                                    {salesOrder.supplier.name}
                                                </strong>
                                            </Link>
                                        ) : (<div>
                                                Неизвестно
                                            </div>
                                        )}
                                    </div>
                                    <div
                                        className="actual-enterprises_card_body__group_row__name">
                                        {salesOrder.address}
                                    </div>
                                    <div
                                        className="actual-enterprises_card_body__group_row__name">
                                        {salesOrder.getReadableStatus()}
                                    </div>
                                    <div
                                        className="actual-enterprises_card_body__group_row__detail">
                                        <div
                                            className="actual-enterprises_card_body__group_row__volume">
                                            {salesOrder.volume}
                                        </div>
                                        <div
                                            className="actual-enterprises_card_body__group_row__detail-price">
                                            {salesOrder.price}
                                        </div>
                                        <div
                                            className={`actual-enterprises_card_body__group_row__detail-date-from` + (salesOrder.willExpireSoon ? ' highlight' : '')}>
                                            {salesOrder.createdAt}
                                        </div>
                                        <div
                                            className={`actual-enterprises_card_body__group_row__detail-date-to` + (salesOrder.willBeExpiredSoon ? ' highlight' : '')}>
                                            {salesOrder.overdueAt}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div> : null
                    }
                )}
            </div>
          </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./components/Search/ActualSuppliers.js